import assistantI18n from './assistant.tr';
import common from './common.tr';
import dashboard from './dashboard.tr';
import date from './date.tr';
import workgroup from './workgroup.tr';
import groupList from './groupList.tr';
import personnelList from './personnelList.tr';
import onboarding from './onboarding.tr';
import login from './login.tr';
import splash from './splash.tr';
import employee from './employee.tr';
import routeList from './routeList.tr';
import employeeList from './employeeList.tr';
import company from './company.tr';
import carpool from './carpool.tr';
import tickets from './tickets.tr';
import survey from './survey.tr';
import flexiride from './flexiride.tr';
import driver from './driver.tr';
import vehicle from './vehicle.tr';
import notifications from './notifications.tr';
import reports from './reports.tr';
import rideShared from './rideShared.tr';
import rider from './rider.tr';
import modules from './modules.tr';
import flexicar from './flexicar.tr';
import routeSchedules from './routeSchedules.tr';
import assignments from './assignments.tr';
import otp from './otp.tr';
import apsr from './apsr.tr';
import scheduling from './scheduling.tr';
import ridership from './ridership.tr';
import myTrips from './myTrips.tr';
import wallet from './wallet.tr';
import block from './block.tr';
import stops from './stops.tr';
import guaranteedRide from './guaranteedRide.tr';
import shuttleRiders from './shuttleRiders.tr';
import reservations from './reservations.tr';

export default {
  common,
  dashboard,
  date,
  workgroup,
  groupList,
  personnelList,
  onboarding,
  login,
  splash,
  employee,
  routeList,
  employeeList,
  shuttleRiders,
  company,
  carpool,
  tickets,
  survey,
  flexiride,
  driver,
  vehicle,
  notifications,
  reports,
  rideShared,
  rider,
  modules,
  flexicar,
  routeSchedules,
  assignments,
  otp,
  apsr,
  scheduling,
  ...ridership,
  myTrips,
  wallet,
  block,
  guaranteedRide,
  reservations,
  ...stops,
  ...assistantI18n,
};
